import React from 'react'
import PropTypes from 'prop-types'

//components
import { Checkbox } from './..'

//styles
import styles from './QuestionCheckboxes.module.scss'

const QuestionCheckboxes = ({ onClick, selectedKeys, questions }) => {
  return questions.map(question => {
    const { topicKey, message } = question
    const checked = selectedKeys.includes(topicKey)
    const handleClick = () => {
      onClick(topicKey)
    }

    return (
      <div
        key={topicKey}
        className={styles.questionCheckboxContainer}
        onClick={handleClick}
        role='button'
      >
        <Checkbox pill name={topicKey} children={message} checked={checked} />
      </div>
    )
  })
}

QuestionCheckboxes.propTypes = {
  onClick: PropTypes.func,
  selectedKeys: PropTypes.array,
  questions: PropTypes.array,
}

export default QuestionCheckboxes
